class CartDrawerCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = parseInt(this.dataset.end, 10) * 1000;
    this.expiredText = this.dataset.expiredText || '';
    this.timerEl = this.querySelector('.cart-drawer-banner-countdown__timer');
    this.expiredEl = this.querySelector('.cart-drawer-banner-countdown__expired');
    this.segments = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      if (this.timerEl) this.timerEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
      if (!this.expiredText && this.dataset.designMode !== 'true' && this.closest('.shopify-section')) {
        this.closest('.shopify-section').style.display = 'none';
      }
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.segments.days) {
      this.segments.days.dataset.label = days > 0 ? `${days}d ` : '';
    }
    if (this.segments.hours) {
      this.segments.hours.dataset.label = `${String(hours).padStart(2, '0')}h `;
    }
    if (this.segments.minutes) {
      this.segments.minutes.dataset.label = `${String(minutes).padStart(2, '0')}m `;
    }
    if (this.segments.seconds) {
      this.segments.seconds.dataset.label = `${String(seconds).padStart(2, '0')}s`;
    }
  }
}

customElements.define('cart-drawer-countdown', CartDrawerCountdown);
